import config from "@/config"

export function building(fieldName: string, row: any): { url: string, text: string } {
  return {
    url: `${config.IPR_BASE_URL}/pages/locationjumper.asp` +
      `?id=${encodeURIComponent(row.BuildingId)}`,
    text: row.BuildingName,
  }
}

export function site(fieldName: string, row: any): { url: string, text: string } {
  return {
    url: `${config.IPR_BASE_URL}/pages/locationjumper.asp` +
      `?id=${encodeURIComponent(row.SiteId)}`,
    text: row.SiteName,
  }
}

export function region(fieldName: string, row: any): { url: string, text: string } {
  return {
    url: `${config.IPR_BASE_URL}/pages/locationjumper.asp` +
      `?id=${encodeURIComponent(row.RegionId)}`,
    text: row.RegionName,
  }
}

export function element(fieldName: string, row: any): { url: string, text: string } {
  return {
    url: `${config.IPR_BASE_URL}/pages/compliance/console.aspx` +
      `?elemid=${encodeURIComponent(row.elementId || row.ElementId)}&selectedlocationid=${encodeURIComponent(row.buildingId || row.BuildingId)}`,
    text: row.elementDescription || row.ElementDescription,
  }
}

export function consoleUrl(locationId: string): string {
  return `${config.IPR_BASE_URL}/pages/compliance/console.aspx` +
  `?selectedlocationid=${encodeURIComponent(locationId)}`
}
